import { render } from "./EventSlider.vue?vue&type=template&id=a28fa49e&ts=true"
import script from "./EventSlider.vue?vue&type=script&lang=ts"
export * from "./EventSlider.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Episcenter\\smartCity\\smartcity\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__